import PageWrapper from './PageWrapper';

export default PageWrapper;
export type { IPageWrapperProps } from './PageWrapper';
